import { rgba } from "polished";
export function progressIndicatorConfig({ colors }) {
    return {
        innerOverlay: {
            background: rgba(colors.boxShadowBackground, 0.8)
        }
    };
}
